import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-comment-popover',
    templateUrl: './comment-popover.component.html',
    styleUrls: ['./comment-popover.component.scss'],
    imports: [IonicModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentPopoverComponent implements OnInit {

  constructor() { }

  readonly comment = input<string>(undefined);

  ngOnInit() {}

}
